import { render, staticRenderFns } from "./AllProcesses.vue?vue&type=template&id=0bdbb982&"
import script from "./AllProcesses.vue?vue&type=script&lang=js&"
export * from "./AllProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports